import request from "./request.js";

// 我学习的课程
export let getStudentStudyCourseList = data => {
  return request("/edu/course/getStudentStudyCourseList", data);
};

// 我被邀约的课程
export let getMyInvitedCourseList = data => {
  return request("/edu/course/getMyInvitedCourseList", data);
};

// 获取我关注的老师列表
export let getMyFollowTeacherList = data => {
  return request("/edu/student/getMyFollowTeacherList", data);
};

// 获取我的老师列表
export let getMyTeacherList = data => {
  return request("/edu/student/getMyTeacherList", data);
};

// 获取学生个人信息
export let getBaseInfo = data => {
  return request("/edu/student/getBaseProfile", data);
};

// 获取学生课程信息
export let getStudentInvitedCourseList = data => {
  return request("/edu/course/getStudentInvitedCourseList", data);
};

// 获取学生个人详细信息
export let getMyProfile = data => {
  return request("/edu/student/getMyProfile", data);
};

// 完善学生资料
export let profectProfile = data => {
  return request("/edu/student/perfectMyProfile", data);
};

// 预约课程
export let orderCourse = data => {
  return request("/edu/course/order/create", data);
};

// 支付订单
export let payOrder = data => {
  return request("/pay/order/payOrder", data);
};

// 获取订单详情
export let getOrder = data => {
  return request("/edu/course/order/query", data);
};

// 评价课程
export let commentCourse = data => {
  return request("/edu/course/comment/create", data);
};

// 充值
export let recharge = data => {
  return request("/edu/recharge/order/create", data);
};

// 学生注册通过邮箱
export let regStudentByEmail = data => {
  return request("/edu/student/regStudentByEmailV2", data);
};
// 学生注册通过手机
export let regStudentByMobile = data => {
  return request("/edu/student/regStudentByMobile", data);
};